import { BrandedParagraph, H3, Paragraph } from "App/global-style";

import { TextManager } from "Components/TextContext";
import { isRiskInsurance } from "Store/interfaces/products";
import { useIsCoopBranding } from "Store/partners/partnerHooks";
import { insuranceNameFromUrl } from "Utils/navigation/urlUtils";
import React from "react";
import { CoopBenefit } from "./CoopBenefit";
import { BenefitsWrapper } from "./coopBenefitsStyled";

export const CoopBenefits = (): React.ReactElement | null => {
  const isCoopBranding = useIsCoopBranding();
  const { getText } = TextManager;
  const product = insuranceNameFromUrl(window.location.href);

  /**
   * Only show if Coop and relevant product.
   */
  if (isCoopBranding && isRiskInsurance(product)) {
    return (
      <>
        <BrandedParagraph>
          <H3>{getText("benefits.coop.coopinsurancebenefits-header")}</H3>
          <Paragraph>
            {getText("benefits.coop.coopinsurancebenefits-paragraph")}
          </Paragraph>
          <BenefitsWrapper>
            <CoopBenefit
              quantity={getText("benefits.coop.coopdiscount-value")}
              title={getText("benefits.coop.coopdiscount-title")}
              description={getText("benefits.coop.coopdiscount-description")}
            />
            <CoopBenefit
              quantity={getText("benefits.coop.coopwebdiscount-value")}
              title={getText("benefits.coop.coopwebdiscount-title")}
              description={getText("benefits.coop.coopwebdiscount-description")}
            />
          </BenefitsWrapper>
        </BrandedParagraph>
        <BrandedParagraph>
          <H3>{getText("benefits.coop.coopmembershipbenefits-header")}</H3>
          <Paragraph>
            {getText("benefits.coop.coopmembershipbenefits-paragraph")}
          </Paragraph>
          <BenefitsWrapper>
            <CoopBenefit
              quantity={getText("benefits.coop.coopwelcomebonus-value")}
              title={getText("benefits.coop.coopwelcomebonus-title")}
              description={getText(
                "benefits.coop.coopwelcomebonus-description",
              )}
            />
            <CoopBenefit
              quantity={getText("benefits.coop.coopmemberbonus-value")}
              title={getText("benefits.coop.coopmemberbonus-title")}
              description={getText("benefits.coop.coopmemberbonus-description")}
            />
            <CoopBenefit
              quantity={getText("benefits.coop.coopnodamagesbonus-value")}
              title={getText("benefits.coop.coopnodamagesbonus-title")}
              description={getText(
                "benefits.coop.coopnodamagesbonus-description",
              )}
            />
          </BenefitsWrapper>
        </BrandedParagraph>
      </>
    );
  }

  return null;
};
